import { AccountNav } from "../components/account/AccountNav";
import { Breadcrumbs } from "../components/global/Breadcrumbs";
import { Outlet, useLocation } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../contexts/UserContext";
import "./accountLayout.css"

export function AccountLayout() {
    const location = useLocation()
    const locationParams = location.pathname.split("/")

    const userDataContext = useContext(UserContext)
    const { user } = userDataContext

    return (
        <div className="my-account mx-auto">

            <div className="d-flex justify-content-between align-items-center">
                <Breadcrumbs dynamicPath={
                    locationParams.length === 3 ?
                        locationParams[2].charAt(0).toUpperCase() + locationParams[2].slice(1)
                        :
                        ""
                    }
                />
                <div className="welcome-user">
                    Welcome! <span>{user && (user.firstName + " " + user.lastName)}</span>
                </div>
            </div>

            <div className="d-flex justify-content-between mt-3 account-wrapper lg-row">

                <AccountNav />
                <div className="account-outlet w-100">
                    <Outlet />
                </div>
            
            </div>

        </div>
    )
}